import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { IGeneralProps } from "types";
import { TalentProfile } from "features/settings/types";

export const QUERY_KEY_FOR_ALL_JOB_APPLICANTS = "all-suggested-applicants";

const getAllSuggestedTalents = async (
    props: IGeneralProps
) => {
    const id = props.id;
    const url = `${END_POINT.BASE_URL}/v1/all-suggested-talents/${id}`;
    const config = {
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${props.token}`,
        },
    };

    const res = await axios.get(url, config);
    const data = res.data;


    return data;
};

export const useGetAllSuggestedTalents = ({ id, token }: IGeneralProps) => {
    const queryData = useQuery([QUERY_KEY_FOR_ALL_JOB_APPLICANTS, id], () =>
        getAllSuggestedTalents({
            id,
            token,
        })
    );

    return queryData;
};
